@if (cmisEntries) {
  <div>
    <div class="modal-header">
      <h5 class="modal-title">
        <strong>{{ modalTitle | translate }}</strong>
      </h5>
    </div>
    <div class="modal-body">
      <p class="dokumentModalTitle">
        {{ "EBelege" | translate }}
      </p>
      @for (entry of cmisEntries; track entry.cmisId) {
        <div>
          <button (click)="getDokument(entry)" class="btn btn-link" type="button">
            {{ decode(entry.fileName | translate) }}
          </button>
          <span aria-hidden="true" class="far fa-file-pdf"></span>
        </div>
      }
    </div>
    <div class="modal-footer">
      <button (click)="activeModal.close('Close click')" class="btn btn-outline-primary" type="button">
        {{ "cmisModal.fensterSchliessen" | translate }}
      </button>
    </div>
  </div>
}
